import { Box, Checkbox, FormControlLabel, TextField } from '@mui/material'
import { Stack } from '@mui/system'
import React from 'react'
import { sendParameters } from '../../../common/functions'
import FileUpload from '../../../components/file/FileUpload'
import FileViewWidget from '../../../components/file/FileView'
import TaskWrapper from './TaskWrapper'

export default function CalculationNecessityTask({ task, isCanceled }) {
  const [needsCalculation, setNeedsCalculation] = React.useState(
    task.meta?.needsCalculation || false
  )
  const [workType, setWorkType] = React.useState(task.meta?.workType || '')
  const [networkType, setNetworkType] = React.useState(
    task.meta?.networkType || ''
  )
  const [files, setFiles] = React.useState([])

  const handleNeedsCalculationChange = (value) => {
    setNeedsCalculation(value)
    setFiles([])
  }

  const enabled = task.isActive && task.accessFlags.update && !isCanceled

  return (
    <TaskWrapper
      task={task}
      label="Исполняющий отдел"
      isCanceled={isCanceled}
      onSave={() =>
        sendParameters(
          task.paidServiceId,
          task.id,
          { needsCalculation, workType, networkType },
          files
        )
      }
    >
      <Stack direction="column" gap="1rem">
        <FormControlLabel
          control={
            <Checkbox
              disabled={!enabled}
              value={needsCalculation}
              checked={needsCalculation}
              onChange={(e) => handleNeedsCalculationChange(e.target.checked)}
            />
          }
          label="Требуется калькуляция"
        />

        {enabled ? (
          <>
            {needsCalculation && (
              <FileUpload
                files={files}
                onUpload={(file) => setFiles([...files, file])}
                onDelete={(id) =>
                  setFiles(files.filter((file) => file.id === id))
                }
              />
            )}
            <TextField
              disabled={!enabled}
              value={workType}
              onChange={(e) => setWorkType(e.target.value)}
              label="Вид работ"
            />
            <TextField
              disabled={!enabled}
              value={networkType}
              onChange={(e) => setNetworkType(e.target.value)}
              label="Параметры сети"
            />
          </>
        ) : (
          <>
            {task.meta?.workType && (
              <TextField disabled={true} value={task.meta?.workType} />
            )}
            {task.meta?.networkType && (
              <TextField disabled={true} value={task.meta?.networkType} />
            )}
            <FileViewWidget files={task.files} />
          </>
        )}
      </Stack>
    </TaskWrapper>
  )
}
